import Web from './WebApi.production'

export default { Web }
